import React from 'react';
import Graphic from '../../../../assets/svg/Graphic.svg';
import NFTButton from '../../newComponents/NFTButton';
import { CardCarouselWrapper, DashboardBanner, DashboardContainer, DashboardFooter, DashboardSection, DashboardSectionTitle, DashboardTopSection, DashboardWrapper, FooterLogo, NewsImage, NewsSectionWrapper, PopularCollectionWrapper, SectionList, SectionListItem, SectionListWrapper, TopSellerDescription, TopSellerImage, TopSellerItem, TopSellerTitle, TopSellerWrapper } from './styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRocket, faPaintBrush } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from 'react-router-dom';
import NFTUserAvatar from '../../components/NFTUserAvatar';
import { useTheme } from 'styled-components';
import Scrollbar from '../../components/Scrollbar';
import { ReactComponent as PaladinLogo } from '../../../../assets/svg/paladin.svg'
import NFTPopularCollection from '../../components/NFTPopularCollection';
//@ts-ignore
import { Helmet } from 'react-helmet';
import CardCarousel from '../../newComponents/CardCarousel';
import { getLastSoldNFTList, getSalesNFTList } from '../../../../services/NFTMarketPlace/Graphquery';
import { getTokenPrice } from '../../../../services/NFTMarketPlace/ApiCall';
import IPriceInfo from '../../models/IPriceInfo';
import { useActiveWeb3React } from '../../../../hooks';
import NFTMarketItem from '../Market/components/NFTMarketItem';
import INFTSalesList from '../../models/INFTSalesList';
import DashboardCarousel from './DashboardCarousel';
import INFTBestUser from '../../models/INFTBestUser';
import { NFTMarketServices } from '../../data/Services';
import DashboardTopUser from './DashboardTopUser';
import DashboardNewsItem from './DashboardNewsItem';
import INewsItem from '../../models/INewsItem';
import IFeaturedCollection from '../../models/IFeaturedCollection';
import { loadCollectionLikeCounts, loadNFTLikeCounts } from '../../data/useNFTLikeCount';
import Logo from '../../../../assets/logo/logo.png'
import SocialLinks from '../../data/SocialLinks';
import { ReactComponent as PoweredbyAvalanche } from '../../../../assets/svg/PoweredbyAvalanche.svg'
import FooterLinks from '../../data/FooterLinks';

const Dashboard = (props: any) => {
    const { account } = useActiveWeb3React();
    const navigator = useHistory();
    const theme = useTheme();
    const onClickExplore = React.useCallback(() => { navigator.push("/explore") }, [])
    const onClickCreate = React.useCallback(() => { navigator.push("/nft-create") }, [])
    const [lastSoldList, setLastSoldList] = React.useState<INFTSalesList[]>([]);
    const [highlightedList, setHighlightedList] = React.useState<INFTSalesList[]>([]);
    const [priceInfo, setPriceInfo] = React.useState<IPriceInfo | null>(null);
    const [bestSellerList, setBestSellerList] = React.useState<INFTBestUser[]>([]);
    const [bestBuyerList, setBestBuyerList] = React.useState<INFTBestUser[]>([]);
    const [newsList, setNewsList] = React.useState<INewsItem[]>([]);
    const [featuredCollectionList, setFeaturedCollectionList] = React.useState<IFeaturedCollection[]>([]);

    React.useEffect(() => {
        getTokenPrice().then((res: any) => setPriceInfo(res))
    }, [])

    React.useEffect(() => {
        fetchLastSoldNFTList();
        fetchLastListedNFTList();

        NFTMarketServices.GetBestBuyerUserData().then((res: any) => {
            setBestBuyerList(res);
        });

        NFTMarketServices.GetBestSellerUserData().then((res: any) => {
            setBestSellerList(res);
        });

        NFTMarketServices.GetNewsData().then((res: any) => {
            setNewsList(res);
        });

        NFTMarketServices.GetFeaturedCollectionsData().then((res: any) => {
            setFeaturedCollectionList(res);
            loadCollectionLikeCounts(res.map((r: IFeaturedCollection) => ({ collectionAddress: r.contractAddress.toLowerCase() })))
        });
    }, [])

    const fetchLastListedNFTList = React.useCallback(() => {
        getSalesNFTList({
            perPage: 3,
            skipItems: 0,
            collection: "ALL",
            categoryId: 0,
            currency: "ALL",
            sortItems: "NewestItems"
        }).then(res => {
            setHighlightedList(res);
            loadNFTLikeCounts(res.map((r: INFTSalesList) => ({ collectionAddress: r.tokenContract, tokenID: r.tokenId })));
        })
    }, [setHighlightedList]);

    const fetchLastSoldNFTList = React.useCallback(() => {
        getLastSoldNFTList(12).then(res => {
            setLastSoldList(res);
            loadNFTLikeCounts(res.map((r: INFTSalesList) => ({ collectionAddress: r.tokenContract, tokenID: r.tokenId })));
        });
    }, [setLastSoldList]);

    return (
        <DashboardWrapper>
            <Helmet>
                <title>{"YetiSwap NFT Marketplace"}</title>
            </Helmet>
            <Scrollbar>
                <DashboardContainer>
                    <DashboardTopSection style={{ backgroundImage: `url(${Graphic})` }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 2rem' }}>
                            <h1 style={{ fontSize: '2.5rem', margin: '20px 0' }}>Explore, Discover</h1>
                            <h1 style={{ fontSize: '3rem', margin: '20px 0' }} >Awesome NFTs</h1>
                            <h3>Marketplace for awesome collections of NFTs</h3>
                            <div style={{ display: 'flex', width: 350, height: 80, padding: 15, justifyContent: 'space-between' }}>
                                <NFTButton style={{ height: 50, width: 150, flex: 'unset' }} onClick={onClickExplore}><FontAwesomeIcon icon={faRocket} size={"1x"} style={{ marginRight: 5 }} />Explore</NFTButton>
                                <NFTButton style={{ height: 50, width: 150, flex: 'unset', background: theme.text5, color: theme.text1 }} onClick={onClickCreate}><FontAwesomeIcon icon={faPaintBrush} size={"1x"} style={{ marginRight: 5 }} />Create</NFTButton>
                            </div>
                        </div>
                        {highlightedList.length > 0 &&
                            <CardCarouselWrapper>
                                <CardCarousel autoPlay={true} autoPlaySpeed={3000} spread={"medium"}>
                                    {highlightedList.map((item, index) => (
                                        <NFTMarketItem
                                            key={`${item.id}_${item.tokenContract}_MARKET`}
                                            item={item}
                                            getSalesNFTItems={fetchLastListedNFTList}
                                            account={account ? account : ''}
                                            priceInfo={priceInfo}
                                        />
                                    ))}
                                </CardCarousel>
                            </CardCarouselWrapper>
                        }
                    </DashboardTopSection>
                    {newsList.length > 0 &&
                        <DashboardSection key={"newsList"}>
                            <DashboardSectionTitle>News</DashboardSectionTitle>
                            <NewsSectionWrapper>
                                <DashboardCarousel dataKey='news' itemWidth={375} autoPlay slideCount={1}>
                                    {newsList.map((item, index) => (
                                        <DashboardNewsItem
                                            key={`news_${index}`}
                                            data={item}
                                        />
                                    ))}
                                </DashboardCarousel>
                            </NewsSectionWrapper>
                        </DashboardSection>
                    }
                    {featuredCollectionList.length > 0 &&
                        <DashboardSection key={"featuredCollections"}>
                            <DashboardSectionTitle>Featured Collections</DashboardSectionTitle>
                            <PopularCollectionWrapper>
                                <DashboardCarousel dataKey='featuredCollections' itemWidth={400} slideCount={1} >
                                    {featuredCollectionList.map((c, i) => (<NFTPopularCollection key={"featured_" + i} data={c} />))}
                                </DashboardCarousel>
                            </PopularCollectionWrapper>
                        </DashboardSection>
                    }
                    {bestSellerList.length > 0 &&
                        <DashboardSection key={"bestSellerList"}>
                            <DashboardSectionTitle>Top Sellers</DashboardSectionTitle>
                            <TopSellerWrapper>
                                <DashboardCarousel dataKey='topSellers' itemWidth={150} slideCount={1} >
                                    {bestSellerList.map((user, i) => (
                                        <DashboardTopUser key={user.address} data={user} type="seller" />
                                    ))}
                                </DashboardCarousel>
                            </TopSellerWrapper>
                        </DashboardSection>
                    }
                    <DashboardBanner onClick={onClickExplore}>
                        <h1>Explore More Collections</h1>
                    </DashboardBanner>
                    {bestBuyerList.length > 0 &&
                        <DashboardSection key={"bestBuyerList"}>
                            <DashboardSectionTitle>Top Buyers</DashboardSectionTitle>
                            <TopSellerWrapper>
                                <DashboardCarousel dataKey='topBuyers' itemWidth={150} slideCount={1}>
                                    {bestBuyerList.map((user, i) => (
                                        <DashboardTopUser key={user.address} data={user} type="buyer" />
                                    ))}
                                </DashboardCarousel>
                            </TopSellerWrapper>
                        </DashboardSection>
                    }
                    {lastSoldList.length > 0 &&
                        <DashboardSection key={"lastSoldList"}>
                            <DashboardSectionTitle>Last Sold NFTs</DashboardSectionTitle>
                            <SectionListWrapper>
                                <DashboardCarousel dataKey='featuredNFTs' itemWidth={350} slideCount={1}>
                                    {lastSoldList.map((item, index) => {
                                        return (
                                            <SectionListItem key={index}>
                                                <NFTMarketItem
                                                    key={`${item.id}_${item.tokenContract}_MARKET`}
                                                    item={item}
                                                    getSalesNFTItems={fetchLastSoldNFTList}
                                                    account={account ? account : ''}
                                                    priceInfo={priceInfo}
                                                />
                                            </SectionListItem>
                                        )

                                    })}
                                </DashboardCarousel>
                            </SectionListWrapper>
                        </DashboardSection>
                    }
                </DashboardContainer >
                <DashboardFooter>
                    <div className='footerSection'>
                        <FooterLogo>
                            <img width={'50px'} src={Logo} alt="logo" />
                            <h2>YetiSwap NFT Marketplace</h2>
                        </FooterLogo>
                        <span>{`Copyright @ ${new Date().getFullYear()} YetiSwap`}</span>
                    </div>
                    <div className='footerSection'>
                        <div className='footerSectionTitle'>Links</div>
                        {FooterLinks.map((item, index) => (<a key={"footerLink_" + index} title={item.name} target="_blank" className='footerLink' href={item.link}>{item.name}</a>))}
                    </div>
                    <div className='footerSection'>
                        <div className='footerSectionTitle'>Social Media</div>
                        {SocialLinks.map((item, index) => (<a key={"socialLink_" + index} title={item.name} target="_blank" className='footerLink' href={item.link}>{item.icon}{item.name}</a>))}
                    </div>
                    <div className='footerSection'>
                        <div className='footerSectionTitle'>Audit</div>
                        <a href="https://paladinsec.co/projects/yetiswap-nft-marketplace/" target="_blank">
                            <PaladinLogo width="100px" />
                        </a>
                        <PoweredbyAvalanche width="100px" height={"36px"} />
                    </div>

                </DashboardFooter>
            </Scrollbar>
        </DashboardWrapper >
    )
}


export default Dashboard;